module.exports = __webpack_public_path__ + "img/Main@2x.f0396b2c.png";